import {useUserRoles} from 'src/hooks/useUserRoles';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {ChangeRequestStatus} from 'src/openapi/models/ChangeRequestStatus';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';
import {Role} from 'src/openapi/models/Role';

export const useIsInReviewStatus = (
    changeRequest: ChangeRequest,
): EventBasicInfo | null => {
    const userRoles = useUserRoles();

    const isInReviewStatus = changeRequest.status === ChangeRequestStatus.IN_REVIEW;
    const isReviewer = userRoles.includes(Role.ROLE_UDEDT_REVIEWER);

    return isInReviewStatus && isReviewer;
};
